var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMensa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4909 2.76126C15.6667 2.43401 15.2682 2.53326 15.2682 2.53326C15.2682 2.53326 12.6114 5.08351 12.2422 4.77101C11.8729 4.45851 14.8434 2.01426 14.4919 1.55751C14.1667 1.13176 11.5569 4.17126 11.2434 3.80001C10.9329 3.42951 13.4782 0.769264 13.4782 0.769264C13.4782 0.769264 13.5749 0.368764 13.2502 0.544264C9.24843 2.69626 8.73868 4.70251 8.73868 4.70251C8.73868 4.70251 8.60093 5.09326 8.89993 5.39526C8.92918 5.42151 1.59893 12.7103 0.617677 13.6943C0.140177 14.1713 1.89218 15.8945 2.36668 15.4175C3.34818 14.4335 10.6227 7.09176 10.6489 7.11901C10.9507 7.42026 11.3404 7.28201 11.3404 7.28201C11.3404 7.28201 13.3434 6.77076 15.4909 2.76126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04266 10.1268C9.99341 12.0818 13.2822 15.3765 13.2822 15.3765C13.2822 15.3765 14.7177 14.9068 14.9199 13.6943L9.70116 8.46527C9.14782 9.0186 8.59499 9.57243 8.04266 10.1268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47567 8.43227C6.17541 7.73309 6.87432 7.03309 7.57242 6.33227L1.90042 0.649518C1.90042 0.649518 1.79792 0.542018 1.57217 0.768768C1.12392 1.21552 0.256669 4.06202 3.93342 7.74427C4.51617 8.32827 5.02317 8.40927 5.47567 8.43227Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensa);
export default __webpack_public_path__ + "static/media/mensa.46810117e7169ae86e8153d0acfe71fb.svg";
export { ForwardRef as ReactComponent };